export const statusCancel = status => {
    switch ( String(status) ) {
        case 'CANCEL_FAIL':
            return { status: `ยกเลิกไม่สำเร็จ` , color: `status-parcel-danger`}
        case 'CANCEL':
            return { status: `ยกเลิกสำเร็จแล้ว` , color: `status-parcel-success`} 
        case 'PENDING_CANCEL':
            return { status: `รอดำเนินการยกเลิก` , color: `status-parcel-warning`} 
        default:
            return { status: `-` , color: `dark`}
    }
};